import React from 'react';

import { useSidebarResetCounter } from '@futrli/predict/hooks/useSidebarResetCounter/useSidebarResetCounter';

import { LockForecastDialog } from './lock-forecast-dialog';

interface LockForecastDialogContainerProps {
  forecastId?: string;
  isOpen: boolean;
  onClose: () => void;
}

export const LockForecastDialogContainer = ({ forecastId, isOpen, onClose }: LockForecastDialogContainerProps) => {
  const { resetKey } = useSidebarResetCounter(isOpen);

  if (forecastId && isOpen) {
    return <LockForecastDialog key={resetKey} forecastId={forecastId} isOpen={isOpen} onClose={onClose} />;
  }
  return null;
};
